import React from "react"
import { Box, BoxProps, useMediaQuery, useTheme } from "@carrotfertility/carotene-core"
import { PartnerAccessAccountBanner } from "components/partner-access/PartnerAccessBanner"
import { useUserRole } from "components/partner-access/hooks/usePartnerAccess"
import { UserDropdown } from "../user-dropdown"

type PageLayoutProps = BoxProps & {
  footer?: React.ReactNode
  header?: React.ReactNode
}

const footerAdjustmentStyles: Pick<BoxProps, "display" | "flexDirection" | "height"> = {
  display: "flex",
  flexDirection: "column",
  height: "100%"
}

export function PageLayout({ footer, header, children }: PageLayoutProps) {
  const { isPartnerAccessingAccount } = useUserRole()
  const theme = useTheme()
  const showUserDropdown = useMediaQuery(theme.breakpoints.up("md"))
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="center"
      marginX={(theme) => ({
        xs: theme.spacing(theme.tokens.spacing.lg),
        lg: theme.spacing(theme.tokens.spacing.xxxl)
      })}
    >
      <Box
        maxWidth={{ xl: "968px", md: "calc(100vw - 250px)", xs: "100vw" }}
        width="100%"
        {...(footer ? footerAdjustmentStyles : {})}
      >
        {showUserDropdown ? (
          <>
            <Box display="flex" justifyContent="flex-end" marginTop="4rem">
              <UserDropdown />
            </Box>
            {header}
          </>
        ) : (
          <Box marginTop={(theme) => theme.spacing(theme.tokens.spacing.xl)}>{header}</Box>
        )}
        {isPartnerAccessingAccount && <PartnerAccessAccountBanner />}
        <Box
          marginTop={(theme) => ({
            xs: theme.spacing(theme.tokens.spacing.lg),
            md: theme.spacing(theme.tokens.spacing.xl)
          })}
          marginBottom={{ xs: "6rem", md: "3rem" }}
        >
          {children}
        </Box>
        {footer}
      </Box>
    </Box>
  )
}
